import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { BurgerMenuEventHandler } from '@ClientBase/Generic/BurgerMenuEventHandler'
import { PostTiles } from './PostTiles'
import * as CtaBanner from './CtaBanner'
// import { Accordion } from './Accordion' // Removed duplicate import
import * as mainNav from './MainNavigationHandler'
import { DomMainipulations } from './DomMainipulations'
import { Carousels } from './Carousels'
import { BrandSnippet } from './BrandsSnippet'
import { HompageScroll } from './HompageScroll'
import { SearchOverlay } from 'SearchOverlay'
import { PostFiltersEventHandler } from '@ClientBase/Generic/PostFiltersEventHandler'
import { Filters } from './Filters'
import * as JobTile from './JobTile'
import { JobFilters } from './JobFilters'
import { PostFilters } from './PostFilter'
import { SecondaryNavigation } from './SecondaryNavigation'
import { PostDetailsPage } from './PostDetailsPage'
import * as ApplyBtn from './ApplyBtn'
import { BrandLandingPage } from './BrandLandingPage'
import { HeartSnippet } from './HeartSnippet'
import * as CountdownSnippet from './TimerSnippet'
import * as VideoSnippet from './VideoSnippet'
import * as TimeLine from './TimeLine'
import * as OldJobFilters from './OldJobFilters'
import * as StatsTiles from './StatsTiles'
import * as AccordionThree from './AccordionThree'
import * as ColorVars from './ColorVars'
import * as TabSwitcher from './TabSwitcher'
import * as Bio from './Bio'
import * as BrandGrid from './BrandGrid'
import * as NewCarousels from './NewCarousels'
import * as NewJobTile from './NewJobTile'
import * as NewJobFilters from './NewJobFilters'
import * as NewQuickSearchOverlay from './NewQuickSearchOverlay'
import * as NewPostFilters from './NewPostFilters'
import * as SearchWidget from './SearchWidget'
import * as NewNaigationHandlers from './NewNavHandlers'
import * as Alert from './Alert'
import {NewNavHandlers} from './NewNavigationHandlers'
import SnippetHero from './Hero/Hero'
import SnippetIntro from './Intro/Intro'
import SnippetVideo from './Video/Video'
import SnippetMotto from './Motto/Motto'
import SnippetBrands from './Brands/Brands'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetIcons from './Icons/Icons'
import SnippetPride from './Pride/Pride'
import SnippetParagraph from './Paragraph/Paragraph'
import SnippetQuote from './Quote/Quote'
import SnippetLongFormIconContent from './LongFormIconContent/LongFormIconContent'
import SnippetMediaContent from './MediaContent/MediaContent'
import SnippetAccordion from './Accordion/Accordion';
import SnippetTabSwitcher from './TabSwitcher/TabSwitcher';
import SnippetVideoCard from './VideoCard/VideoCard';
import SnippetSpacer from './Spacer/Spacer';
import SnippetInstagram from './Instagram/Instagram';
import SnippetImageRow from './ImageRow/ImageRow'
import SnippetFact from './Fact/Fact'
import SnippetJobLinks from './JobLinks/JobLinks'
import SnippetCountdown from './Countdown/Countdown'
import * as PostAlertWidget from './PostAlertWidget'
import * as JobAlertsWidget from './JobAlertsWidget'
import * as VideoBanner from './video-banner'
import SnippetMapContent from './MapContent/MapContent'
import * as Workflow from "@ClientBase/Generic/WorkFlowStyling";

const _Components = {
    'SnippetHero' : SnippetHero,
    'SnippetIntro' : SnippetIntro,
    'SnippetVideo' : SnippetVideo,
    'SnippetMotto' : SnippetMotto,
    'SnippetBrands' : SnippetBrands,
    'SnippetContentColumn' : SnippetContentColumn,
    'SnippetIcons' : SnippetIcons,
    'SnippetPride' : SnippetPride,
    'SnippetParagraph' : SnippetParagraph,
    'SnippetQuote' : SnippetQuote,
    'SnippetLongFormIconContent' : SnippetLongFormIconContent,
    'SnippetMediaContent' : SnippetMediaContent,
    'SnippetAccordion' : SnippetAccordion,
    'SnippetTabSwitcher' : SnippetTabSwitcher,
    'SnippetVideoCard' : SnippetVideoCard,
    'SnippetSpacer' : SnippetSpacer,
    'SnippetInstagram': SnippetInstagram,
    'SnippetImageRow': SnippetImageRow,
    'SnippetFact': SnippetFact,
    'SnippetJobLinks': SnippetJobLinks,
    'SnippetCountdown': SnippetCountdown,
    'SnippetMapContent': SnippetMapContent,
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        BurgerMenuEventHandler.handleClickEvents($)
        PostTiles.addHasTagToTags($)
        DomMainipulations.showEmptyShortlistMessage($)
        DomMainipulations.locationDropDownClickHandler($)
        DomMainipulations.repostionClearFiltersBtn($)
        DomMainipulations.repostionContactModal($)
        DomMainipulations.ShowOrHidePridePopup($)
        DomMainipulations.moveCarouselReadMoreBtn($)
        NewNavHandlers()
        BrandSnippet.imgReplacement($)
        HompageScroll.scrollTosection($)
        SearchOverlay.clickHandler($)
        SearchOverlay.addSearchLabel($)
        PostFiltersEventHandler.useAttraxTShandler($)
        Filters.clickHandler($)
        NewJobTile.initialise()
        NewJobFilters.initialise()
        JobTile.JobTileFunctions()
        JobFilters.wrapHeading($)
        JobFilters.addClickHandlers($)
        PostFilters.clickHandler($)
        PostDetailsPage.imageReplacement($)
        SecondaryNavigation.getPageTitle($)
        SecondaryNavigation.injectOpenButton($)
        SecondaryNavigation.openSecondaryNav($)
        ApplyBtn.sideApplyFunctions()
        BrandLandingPage.setLogo($)
        HeartSnippet.backgroundReplacement($)
        DomMainipulations.scrollToSections($)
        DomMainipulations.addInstagramFrame($)
        DomMainipulations.hideNavDropdownBanner()
        DomMainipulations.upOrDownOnScrollWheel($)
        CountdownSnippet.SetTimerHandler()
        VideoSnippet.textVideoCLickHandler()
        TimeLine.TimelineScrollHandler()
        OldJobFilters.filterBtnFunctions()
        mainNav.navLevel1LiHoverHanderler()
        StatsTiles.statsCounter()
        AccordionThree.handleAccordion()
        ColorVars.setColorVarsFromAttributes()
        TabSwitcher.SetActiveDropDownHeaderMobile()
        TabSwitcher.TabSwitcherClickHandlers()
        Bio.setRecruiterProfileText()
        Carousels.createCarousels($)
        NewCarousels.initialise()
        BrandGrid.brandGridFunctions()
        CtaBanner.getCtaBanners()
        NewQuickSearchOverlay.initialise()
        NewPostFilters.CloseOpenFiltersOnBodyClick()
        PostAlertWidget.initialise()
        JobAlertsWidget.initialise()
        SearchWidget.initialise()
        VideoBanner.initialise()
        Workflow.HandleIntegratedWorkflows()
        NewNaigationHandlers.initialise()
        Alert.initialise()

        //old site
        if (!document.body.classList.contains("page-redesign")) {
            mainNav.MainNavigationHandler.MobileNavToggle($);
            mainNav.MainNavigationHandler.MobileNavFunctionality($);
            mainNav.MainNavigationHandler.repositionNavBanners($);
            mainNav.MainNavigationHandler.wrapNavItems($);
            mainNav.MainNavigationHandler.DesktopMouseOnNav($);
        }
    }
})

